import { InputGroup } from '@chakra-ui/react';

export default function VInputGroup({
  children,
  startAddonProps = {},
  endAddonProps = {},
  ...props
}) {
  return (
    <InputGroup
      startAddonProps={{ ...startAddonProps }}
      endAddonProps={{ ...endAddonProps }}
      {...props}
    >
      {children}
    </InputGroup>
  );
}
